/**
 * LocaleSelect — 로캘 선택기. 활성 로캘 목록을 포털 기준정보(GET /api/v1/locales, public)에서
 * 동적으로 받아 표시한다(메인앱과 동일 — 하드코딩 제거). 네트워크 실패 시 ko/en/vi 로 폴백.
 * 선택 시 useLabel().setLocale 로 백엔드 라벨 재로딩 + 리렌더.
 * AntD Select 기반. 헤더/로그인 등 어디서나 재사용.
 */
import { useEffect, useState } from 'react'
import { Select } from 'antd'
import { api } from '@/api/client'
import { useLabel, SUPPORTED_LOCALES } from './useLabel'

const LOCALE_LABEL: Record<string, string> = { ko: '한국어', en: 'English', vi: 'Tiếng Việt' }

type LocaleOpt = { value: string; label: string }

// 폴백 옵션 — 기준정보 조회 실패 시 사용(현행 동작 보존).
const FALLBACK_OPTS: LocaleOpt[] = SUPPORTED_LOCALES.map((l) => ({ value: l, label: LOCALE_LABEL[l] ?? l }))

export default function LocaleSelect({ size = 'middle', width = 110 }: { size?: 'small' | 'middle' | 'large'; width?: number }) {
  const { locale, setLocale } = useLabel()
  const [opts, setOpts] = useState<LocaleOpt[]>(FALLBACK_OPTS)

  // 활성 로캘 = 포털 기준정보(cm_locale). nativeName 우선 표기. 실패해도 폴백 유지.
  useEffect(() => {
    let alive = true
    api.get('/api/v1/locales')
      .then((res) => {
        const rows = (res?.data?.data ?? []) as Array<{ locale: string; nativeName?: string; name?: string }>
        if (alive && rows.length > 0) {
          setOpts(rows.map((r) => ({ value: r.locale, label: r.nativeName || r.name || LOCALE_LABEL[r.locale] || r.locale })))
        }
      })
      .catch(() => { /* 기준정보 조회 실패 — 폴백 유지 */ })
    return () => { alive = false }
  }, [])

  return (
    <Select
      size={size}
      value={locale}
      style={{ width }}
      onChange={(v) => { void setLocale(v) }}
      options={opts}
    />
  )
}
